import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { ICategoriesState, ICategoriesUpdateReducer } from "interfaces/redux/reducers";

import { CATEGORIES_SLICE } from "./sliceNames";

const initialState: ICategoriesState = {
  categories: [],
  isFetchingCategories: false,
};

const authorizationSlice = createSlice({
  name: CATEGORIES_SLICE,
  initialState,
  reducers: {
    updateCategoriesReducer: (state, action: PayloadAction<ICategoriesUpdateReducer>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetCategoriesReducer: () => {
      return initialState;
    },
  },
});

export const {
  resetCategoriesReducer: actionResetCategoriesReducer,
  updateCategoriesReducer: actionUpdateCategoriesReducer,
} = authorizationSlice.actions;

export default authorizationSlice.reducer;
